// Drawer.js
import PropTypes from "prop-types";
import { useEffect } from "react";

const Drawer = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("drawer-open");
    } else {
      document.body.classList.remove("drawer-open");
    }

    // Cleanup function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("drawer-open");
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && <div className="backdrop" data-testid="drawer-backdrop"></div>}
      <div className={`drawer w-full flex ${isOpen ? "open" : "closed"}`}>
        {children}
      </div>
    </>
  );
};

Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Drawer;
